var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.loading)?_c('skeleton'):(_vm.isShowTimeout)?_c('timeout'):(_vm.isShowOffline)?_c('offline'):_c('home',{attrs:{"data":_vm.apolloData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }